import { useForm } from 'react-hook-form';
import type { HistoryDateFilter, Language } from '@/shared/types';
import type { PaidInvoicesFormValues } from './types';
import { getDefaultFormValues } from '../lib';

type Props = {
  language: Language;
  defaultDateFilter: HistoryDateFilter | undefined;
  dateFrom?: Date;
  dateTo?: Date;
  formValues?: PaidInvoicesFormValues;
};

const usePaidInvoicesForm = ({
  language,
  defaultDateFilter,
  dateFrom,
  dateTo,
  formValues,
}: Props) => {
  return useForm<PaidInvoicesFormValues>({
    mode: 'onChange',
    defaultValues: getDefaultFormValues(
      language,
      defaultDateFilter,
      dateFrom,
      dateTo,
      formValues
    ),
  });
};

export { usePaidInvoicesForm };
